import React, { useMemo } from 'react'

export const useIcons = () => {
  const CallIcon = useMemo(() => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="57"
        height="61"
        viewBox="0 0 57 61"
        fill="none"
      >
        <path
          d="M38 48H18C16.9 48 16 47.1 16 46V14C16 12.9 16.9 12 18 12H38C39.1 12 40 12.9 40 14V46C40 47.1 39.1 48 38 48Z"
          fill="#0E4686"
        />
        <path
          d="M36.3333 46H19.6667C18.75 46 18 45.2 18 44.2222V15.7778C18 14.8 18.75 14 19.6667 14H36.3333C37.25 14 38 14.8 38 15.7778V44.2222C38 45.2 37.25 46 36.3333 46Z"
          fill="#4383CC"
        />
        <path
          d="M17.5 22C22.1944 22 26 18.1944 26 13.5C26 8.80558 22.1944 5 17.5 5C12.8056 5 9 8.80558 9 13.5C9 18.1944 12.8056 22 17.5 22Z"
          fill="#D4E3F3"
        />
        <rect
          x="19"
          y="16"
          width="3"
          height="9"
          rx="1.5"
          transform="rotate(-180 19 16)"
          fill="#0E4686"
        />
        <circle
          cx="17.5"
          cy="18.5"
          r="1.5"
          transform="rotate(-180 17.5 18.5)"
          fill="#0E4686"
        />
        <circle cx="35.5" cy="28.5" r="1.5" fill="#D4E3F3" />
      </svg>
    )
  }, [])

  return {
    CallIcon,
  }
}
